import React, { useEffect, useState } from 'react'
import dashBoardService from '../Services/dashBoardService';

const StatsCards = () => {


  const [data, setData] = useState(null);

  useEffect(()=>{
    const fetchData = async () => {
      try {
        const response = await dashBoardService.getTravelSummaryData();
        if (response && response.data) {
          setData(response.data);
          console.log("Travel Summary Data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching travel summary data:", error);
      }
    };

    fetchData();
  },[])


  const statsData = [
    // {
    //   id: 1,
    //   value: "44",
    //   label: "Total Employee",
    //   bgColor: "bg-[#D2FAEC]"
    // },
    {
      id: 2,
      value: data?.totalDistance || "0 km",
      label: "Today's Distance Travelled",
      bgColor: "bg-[#D3EEFF]"
    },
    {
      id: 3,
      value: data?.totalTravelTime || "0 hrs",
      label: "Today's Time On Travel",
      bgColor: "bg-[#EBEBFF]"
    }
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 h-[129px] gap-5 mb-8">
      {statsData.map(stat => (
        <div 
          key={stat.id} 
          className={`${stat.bgColor} rounded-xl p-6 shadow-sm border border-gray-100`}
        >
          <div className="text-2xl font-bold text-gray-800 mb-2">
            {stat.value}
          </div>
          <div className="text-sm text-gray-600 font-medium">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  )
}

export default StatsCards